import { Component, NgZone, OnDestroy, OnInit, inject, model, viewChild } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { GoogleChartComponent, GoogleChartInterface, Ng2GoogleChartsModule } from 'ng2-google-charts';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-geo-chart',
  templateUrl: './geo-chart.component.html',
  styleUrl: './geo-chart.component.scss',
  imports: [Ng2GoogleChartsModule],
})
export class GeoChartComponent extends BaseComponent implements OnInit, OnDestroy {
  private readonly viewportRuler = inject(ViewportRuler);
  private readonly ngZone = inject(NgZone);

  private readonly chart = viewChild<GoogleChartComponent>('chart');

  public readonly data = model<Observable<any>>();

  protected tableData: any[][];

  ngOnInit() {
    this.getData();
    this.onResize();
  }

  ngOnDestroy() {
    this.viewportRuler.ngOnDestroy();
  }

  get geoChart(): GoogleChartInterface {
    const { width, height } = this.viewportRuler.getViewportSize();
    return {
      chartType: 'GeoChart',
      dataTable: this.tableData,
      options: {
        colorAxis: { colors: ['yellow', 'red'] },
        width: width - (width > 1400 ? 304 : 64),
        height: height - 197,
      },
    };
  }

  private getData() {
    if (this.data()) {
      this.data()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          if (data?.length > 1) {
            this.tableData = data;
            this.redraw();
          }
        });
    }
  }

  private onResize() {
    this.viewportRuler
      .change()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.ngZone.run(() => this.redraw()));
  }

  private redraw() {
    this.chart()?.draw(this.geoChart);
  }
}
